import React from 'react';

import { RawProjectData } from '@interfaces/projects';

import ProfileDetails from './ProfileDetails';
import ProfileOverview from './ProfileOverview';

interface TalentAccordianProps {
  profile: RawProjectData;
  projectSlug: string;
}

const TalentAccordian = ({ profile, projectSlug }: TalentAccordianProps) => {
  return (
    <section
      key={profile.name}
      className="grid grid-cols-1 border-0 border-t border-solid border-grayscale-beige last-of-type:border-b sm:grid-cols-12"
    >
      <ProfileOverview
        detailsDescription={profile.details_description as string}
        details={profile.details as string}
        image={profile.image as string}
        name={profile.name as string}
        projectSlug={projectSlug}
        title={profile.title as string}
      />
      <ProfileDetails bio={profile.bio as string} name={profile.name as string} />
    </section>
  );
};

export default TalentAccordian;
